import { render } from "./TestimonialsFive.vue?vue&type=template&id=06f34d02"
import script from "./TestimonialsFive.vue?vue&type=script&lang=js"
export * from "./TestimonialsFive.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__